import { CustomPage as CustomPageState } from "../../../../publicSite/publicSite.module"
import { initOverviewWidget, OverviewState } from "../widgets/overviewWidget.state"
import { storyOverviewPageWidget } from "./storyOverviewPage.widget"

export type StoryOverviewPageState = {
    overviewState: OverviewState
} & CustomPageState

export const storyOverviewPageState = (): StoryOverviewPageState => ({
    widget: storyOverviewPageWidget,
    overviewState: initOverviewWidget(true, "verhalen")
})

export type StoryOverviewBlockClassNames = Partial<{
    layout: string,
    empty: string,
    teasers: string,
    teasersList: string,
    teasersItem: string,
    teaser: string,
    teaserLink: string,
    teaserInner: string,
    teaserContent: string,
    teaserMeta: string,
    teaserTitle: string,
    teaserVisual: string,
    teaserImage: string
    teaserCaption: string,
    teaserButton: string
  }>
